<template>
    <div class="fab-container">
        <!-- Chat Button -->
        <div class="fab" title="Chat" @click="openChat()">
            <i class="fas fa-comment"></i> <!-- Chat icon -->
        </div>

        <!-- New Task Button -->
        <div class="fab" title="New Task" @click="createNewTask()">
            <i class="fas fa-plus"></i> <!-- Plus icon -->
        </div>
    </div>
</template>

<script>
// Example for Vue or vanilla JS method triggers

export default {
    props:{
      title:"floating-new-task-btn"
    },
    components: {},
    methods: {
        openChat() {
            alert('Opening Chat!')
            // Add your chat functionality here
        },

        createNewTask() {
            alert('Creating New Task!')
            // Add your task creation functionality here
        },
    },
}

</script>
